
import { useEffect } from "react";

const SEO = ({ title, description }) => {
  useEffect(() => {
    document.title = title;

    // Helper function to set or create meta tags
    const setMetaTag = (name, content, isProperty = false) => {
      const selector = isProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let metaTag = document.querySelector(selector);
      if (metaTag) {
        metaTag.setAttribute("content", content);
      } else {
        metaTag = document.createElement("meta");
        if (isProperty) {
          metaTag.setAttribute("property", name);
        } else {
          metaTag.setAttribute("name", name);
        }
        metaTag.setAttribute("content", content);
        document.head.appendChild(metaTag);
      }
    };

    // Set standard meta tags
    setMetaTag("description", description);
    // setMetaTag("p:domain_verify", "");
    // setMetaTag("google-site-verification", "");
    setMetaTag("keywords", "Solar Panel Installation","Solar Energy Solutions","Solar Power Systems","Solar Panel Cost and Savings","Residential Solar Panels","Commercial Solar Panels","Benefits of Solar Energy","How Solar Panels Work");








    // Set Open Graph meta tags
    setMetaTag("og:locale", "en_US", true);
    setMetaTag("og:type", "website", true);
    setMetaTag("og:title", "Axis Solar | Solarpower panels in hyderabad", true);
    setMetaTag("og:url", "https://www.axissolar.com/", true);
    setMetaTag("og:image", "assets/images/icon.png", true);
    setMetaTag("og:description", "Axis Solar Panels offers top-tier solar panel installation services for residential and commercial properties, helping customers save on electricity costs while reducing their carbon footprint. Our experienced team uses high-quality solar products and the latest technology to ensure maximum energy efficiency and reliability. From the initial solar consultation through custom system design and installation, we manage every step for a smooth transition to clean, renewable energy. We also provide ongoing solar maintenance, tax credit guidance, and financing options, making sustainable energy accessible and affordable. Power your home or business with Axis Solar Panels and contribute to a greener future.", true);

  }, [title, description]);

  return null;
};

export default SEO;
